module.exports = __webpack_public_path__ + "img/platform.438556da.jpg";